// FICHIER : frontend/src/pages/Marque.jsx

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import NavLogo from '../components/NavLogo';

// ── URL du backend ──
const API = 'https://ark-recruitment-backend.onrender.com/api';

// ══════════════════════════════════════════
// ── Icônes ──
// ══════════════════════════════════════════
const IconArrow     = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>);
const IconArrowLeft = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>);
const IconCheck     = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>);

// ══════════════════════════════════════════
// ── Configuration des 5 étapes ──
// ══════════════════════════════════════════
const ETAPES = [
  { n: 1, label: 'Compréhension',  desc: 'Votre entreprise'       },
  { n: 2, label: 'Structuration',  desc: 'ADN & EVP'              },
  { n: 3, label: 'Formalisation',  desc: 'Pitch & contenus'       },
  { n: 4, label: 'Activation',     desc: 'Diffusion'              },
  { n: 5, label: 'Optimisation',   desc: 'Score & recommandations'},
];

// ══════════════════════════════════════════
// ── Composant champ textarea ──
// ══════════════════════════════════════════
function Textarea({ label, hint, value, onChange, placeholder, rows = 4 }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>{label}</label>
      {hint && <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 8, lineHeight: 1.5 }}>{hint}</p>}
      <textarea
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '12px 16px', fontSize: 14, color: 'var(--text)', outline: 'none', fontFamily: 'DM Sans,sans-serif', resize: 'vertical', lineHeight: 1.6 }}
      />
    </div>
  );
}

// ══════════════════════════════════════════
// ── Composant champ input simple ──
// ══════════════════════════════════════════
function Input({ label, hint, value, onChange, placeholder }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>{label}</label>
      {hint && <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 8, lineHeight: 1.5 }}>{hint}</p>}
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '12px 16px', fontSize: 14, color: 'var(--text)', outline: 'none', fontFamily: 'DM Sans,sans-serif' }}
      />
    </div>
  );
}

// ══════════════════════════════════════════
// ── Bloc résultat mocké (placeholder IA) ──
// ══════════════════════════════════════════
function ResultatBlock({ titre, contenu, accent = false }) {
  return (
    <div style={{ background: accent ? 'rgba(107,175,58,0.08)' : 'var(--bg2)', border: `1px solid ${accent ? 'rgba(107,175,58,0.15)' : 'var(--border)'}`, borderRadius: 10, padding: '16px 20px', marginBottom: 14 }}>
      <div style={{ fontFamily: 'Syne,sans-serif', fontSize: 12, fontWeight: 700, color: accent ? 'var(--accent)' : 'var(--accent2)', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8 }}>{titre}</div>
      <p style={{ fontSize: 14, color: 'var(--text)', lineHeight: 1.7, margin: 0 }}>{contenu}</p>
    </div>
  );
}

// ══════════════════════════════════════════
// ── Composant contenu copiable ──
// ══════════════════════════════════════════
function ContenuCopiable({ label, contenu }) {
  const [copie, setCopie] = useState(false);
  const copier = () => {
    navigator.clipboard.writeText(contenu).then(() => {
      setCopie(true);
      setTimeout(() => setCopie(false), 2000);
    });
  };
  return (
    <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden', marginBottom: 14 }}>
      <div style={{ padding: '12px 18px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 11, color: 'var(--accent2)', letterSpacing: 1, textTransform: 'uppercase' }}>{label}</div>
        <button onClick={copier} style={{ background: copie ? 'rgba(22,163,74,0.08)' : 'var(--accent)', color: copie ? 'var(--success)' : '#fff', border: copie ? '1px solid var(--success)' : 'none', borderRadius: 6, padding: '5px 12px', fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: 'DM Sans,sans-serif' }}>
          {copie ? 'Copié !' : 'Copier'}
        </button>
      </div>
      <div style={{ padding: '16px 18px', fontSize: 13, color: 'var(--text)', lineHeight: 1.8 }}>{contenu}</div>
    </div>
  );
}
export default function Marque() {
  const navigate  = useNavigate();

  // ── Détection mobile ──
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  // ── Étape courante (1 à 5) ──
  const [etape, setEtape] = useState(1);

  // ── État global du formulaire ──
  const [form, setForm] = useState({
    // Étape 1 — Compréhension
    nomEntreprise:  '',
    secteur:        '',
    pourquoi:       '',
    probleme:       '',
    ambition:       '',

    // Étape 2 — Structuration
    valeurs:        '',
    culture:        '',
    avantages:      '',
    evolution:      '',

    // Étape 3 — Formalisation
    pitchGenere:    '',
    ficheGenere:    '',
    pageCarriere:   '',

    // Étape 4 — Activation
    postLinkedin:   '',
    messageWhatsapp:'',
    annonceEmploi:  '',

    // Étape 5 — Score
    score:          null,
  });

  // ── Mise à jour d'un champ ──
  const set = (key) => (val) => setForm(f => ({ ...f, [key]: val }));

  // ── Navigation entre étapes ──
  const suivant   = () => { if (etape < 5) setEtape(e => e + 1); };
  const precedent = () => { if (etape > 1) setEtape(e => e - 1); };

  // ── État résultat IA ──
  const [iaResult,  setIaResult]  = useState(null);
  const [iaLoading, setIaLoading] = useState(false);
  const [iaError,   setIaError]   = useState('');

  // ── Appel backend DeepSeek à l'étape 3 ──
  const genererAvecIA = async () => {
    setIaLoading(true);
    setIaError('');
    try {
      const companyId = localStorage.getItem('company_id') || '';
      const res = await axios.post(`${API}/marque/generer`, {
        company_id:    companyId,
        nomEntreprise: form.nomEntreprise,
        secteur:       form.secteur,
        pourquoi:      form.pourquoi,
        probleme:      form.probleme,
        ambition:      form.ambition,
        valeurs:       form.valeurs,
        culture:       form.culture,
        avantages:     form.avantages,
        evolution:     form.evolution,
      });
      setIaResult(res.data);
    } catch (e) {
      setIaError('Erreur de génération. Vérifiez que le backend est en ligne.');
    } finally {
      setIaLoading(false);
    }
  };

  // ── Calcul progression ──
  const progression = ((etape - 1) / (ETAPES.length - 1)) * 100;

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)', fontFamily: 'DM Sans,sans-serif', display: 'flex', flexDirection: 'column' }}>

      {/* ── NAVIGATION ── */}
      <nav style={{ position: 'sticky', top: 0, zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: isMobile ? '0 20px' : '0 32px', height: 64, borderBottom: '1px solid var(--border)', background: 'var(--nav-bg)' }}>
        <NavLogo/>
        <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 11, color: 'var(--muted)', letterSpacing: 1 }}>
          MARQUE <span style={{ color: 'var(--accent2)' }}>EMPLOYEUR</span>
        </div>
        <span onClick={() => navigate('/dashboard')} style={{ color: 'var(--muted)', fontSize: 13, cursor: 'pointer' }}>
          ← Dashboard
        </span>
      </nav>

      {/* ── BARRE DE PROGRESSION ── */}
      <div style={{ background: 'var(--bg2)', borderBottom: '1px solid var(--border)', padding: isMobile ? '16px 20px' : '20px 32px' }}>

        {/* Indicateurs d'étapes */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', maxWidth: 720, margin: '0 auto 14px', gap: 8 }}>
          {ETAPES.map(e => {
            const actif    = etape === e.n;
            const complete = etape > e.n;
            return (
              <div key={e.n} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, flex: 1, cursor: complete ? 'pointer' : 'default' }} onClick={() => complete && setEtape(e.n)}>
                {/* Cercle numéro */}
                <div style={{ width: 32, height: 32, borderRadius: '50%', background: complete ? 'var(--accent)' : actif ? 'var(--accent)' : 'var(--bg3)', border: `2px solid ${complete || actif ? 'var(--accent)' : 'var(--border)'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: complete || actif ? '#fff' : 'var(--muted)', flexShrink: 0 }}>
                  {complete ? <IconCheck/> : e.n}
                </div>
                {/* Label étape — masqué sur mobile petit */}
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: actif ? 'var(--text)' : complete ? 'var(--accent2)' : 'var(--muted)', whiteSpace: 'nowrap' }}>{e.label}</div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Barre de progression */}
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <div style={{ height: 4, background: 'var(--border)', borderRadius: 4, overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${progression}%`, background: 'linear-gradient(90deg, var(--accent2), var(--accent))', borderRadius: 4, transition: 'width 0.4s ease' }}/>
          </div>
        </div>
      </div>

      {/* ── CONTENU ÉTAPE ── */}
      <div style={{ flex: 1, maxWidth: 720, width: '100%', margin: '0 auto', padding: isMobile ? '24px 16px' : '36px 24px' }}>

        {/* ════════════════════════════════════
            ÉTAPE 1 — COMPRÉHENSION
        ════════════════════════════════════ */}
        {etape === 1 && (
          <div>
            <div style={{ marginBottom: 28 }}>
              <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 11, color: 'var(--accent2)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 8 }}>Étape 1 / 5</div>
              <h2 style={{ fontFamily: 'Syne,sans-serif', fontSize: 24, fontWeight: 800, letterSpacing: '-0.8px', marginBottom: 8 }}>Parle-moi de ton entreprise</h2>
              <p style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.7 }}>Ces informations sont la base de ta marque employeur. Sois précis — l'IA s'en sert pour générer ton ADN.</p>
            </div>

            <Input
              label="Nom de votre entreprise"
              value={form.nomEntreprise}
              onChange={set('nomEntreprise')}
              placeholder="Ex : Ark Intelligence"
            />
            <Input
              label="Secteur d'activité"
              value={form.secteur}
              onChange={set('secteur')}
              placeholder="Ex : Intelligence artificielle, Recrutement, Finance..."
            />
            <Textarea
              label="Pourquoi votre entreprise existe ?"
              hint="Quelle est votre raison d'être au-delà du profit ?"
              value={form.pourquoi}
              onChange={set('pourquoi')}
              placeholder="Ex : Nous existons pour démocratiser l'accès aux talents en Afrique grâce à l'IA..."
            />
            <Textarea
              label="Quel problème résolvez-vous ?"
              hint="Décrivez le problème concret que vous adressez."
              value={form.probleme}
              onChange={set('probleme')}
              placeholder="Ex : Les PME africaines recrutent au feeling, sans structure ni outils adaptés..."
            />
            <Textarea
              label="Quelle est votre ambition ?"
              hint="Où voulez-vous être dans 3 à 5 ans ?"
              value={form.ambition}
              onChange={set('ambition')}
              placeholder="Ex : Devenir la plateforme RH de référence en Afrique subsaharienne..."
            />
          </div>
        )}

        {/* ════════════════════════════════════
            ÉTAPE 2 — STRUCTURATION
        ════════════════════════════════════ */}
        {etape === 2 && (
          <div>
            <div style={{ marginBottom: 28 }}>
              <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 11, color: 'var(--accent2)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 8 }}>Étape 2 / 5</div>
              <h2 style={{ fontFamily: 'Syne,sans-serif', fontSize: 24, fontWeight: 800, letterSpacing: '-0.8px', marginBottom: 8 }}>ADN & Proposition de valeur</h2>
              <p style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.7 }}>Définissez ce qui vous rend unique en tant qu'employeur. C'est votre EVP — Employee Value Proposition.</p>
            </div>

            <Textarea
              label="Quelles sont vos valeurs ?"
              hint="Listez 3 à 5 valeurs qui guident vos décisions au quotidien."
              value={form.valeurs}
              onChange={set('valeurs')}
              placeholder="Ex : Excellence, Transparence, Impact, Innovation, Humilité..."
            />
            <Textarea
              label="Comment décrirez-vous votre culture d'entreprise ?"
              hint="L'ambiance, le mode de travail, ce qui vous différencie."
              value={form.culture}
              onChange={set('culture')}
              placeholder="Ex : Équipe jeune et ambitieuse, télétravail flexible, feedback direct, autonomie encouragée..."
            />
            <Textarea
              label="Pourquoi quelqu'un devrait travailler avec vous ?"
              hint="Au-delà du salaire — ce que vous offrez vraiment."
              value={form.avantages}
              onChange={set('avantages')}
              placeholder="Ex : Vous rejoignez un projet qui change le recrutement en Afrique, vous avez un impact réel..."
            />
            <Textarea
              label="Quelle évolution proposez-vous ?"
              hint="Formation, montée en responsabilités, perspectives."
              value={form.evolution}
              onChange={set('evolution')}
              placeholder="Ex : Budget formation annuel, mentoring, possibilité de devenir team lead en 18 mois..."
            />
          </div>
        )}

        {/* ════════════════════════════════════
            ÉTAPE 3 — FORMALISATION
        ════════════════════════════════════ */}
        {etape === 3 && (
          <div>
            <div style={{ marginBottom: 28 }}>
              <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 11, color: 'var(--accent2)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 8 }}>Étape 3 / 5</div>
              <h2 style={{ fontFamily: 'Syne,sans-serif', fontSize: 24, fontWeight: 800, letterSpacing: '-0.8px', marginBottom: 8 }}>Pitch & Contenus formalisés</h2>
              <p style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.7 }}>L'IA génère votre ADN complet à partir de vos réponses.</p>
            </div>

            {/* Bouton de génération IA */}
            {!iaResult && (
              <button
                onClick={genererAvecIA}
                disabled={iaLoading}
                style={{ width: '100%', background: iaLoading ? 'var(--border)' : 'var(--accent)', color: '#fff', border: 'none', borderRadius: 10, padding: '14px 20px', fontSize: 15, fontWeight: 600, fontFamily: 'DM Sans,sans-serif', cursor: iaLoading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 20 }}
              >
                {iaLoading ? 'Génération en cours…' : 'Générer mon ADN avec DeepSeek'}
              </button>
            )}

            {/* Erreur */}
            {iaError && (
              <div style={{ background: 'rgba(220,38,38,0.05)', border: '1px solid rgba(220,38,38,0.12)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'var(--error)', marginBottom: 16 }}>
                {iaError}
              </div>
            )}

            {/* Résultats IA */}
            {iaResult && (
              <>
                <ResultatBlock titre="Mission"            accent contenu={iaResult.mission}/>
                <ResultatBlock titre="Vision"                    contenu={iaResult.vision}/>
                <ResultatBlock titre="EVP — Proposition de valeur employeur" contenu={iaResult.evp}/>
                <ResultatBlock titre="Pitch entreprise"   accent contenu={iaResult.pitch}/>
                <ResultatBlock titre="Promesse employeur"        contenu={iaResult.promesse_employeur}/>
                <ResultatBlock titre="Accroche page carrière"    contenu={iaResult.page_carriere_accroche}/>

                {/* Valeurs formalisées */}
                {iaResult.valeurs_formalisees && (
                  <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '16px 20px', marginBottom: 14 }}>
                    <div style={{ fontFamily: 'Syne,sans-serif', fontSize: 12, fontWeight: 700, color: 'var(--accent2)', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 12 }}>Valeurs formalisées</div>
                    {iaResult.valeurs_formalisees.map((v, i) => (
                      <div key={i} style={{ display: 'flex', gap: 10, fontSize: 14, color: 'var(--text)', lineHeight: 1.6, marginBottom: 8 }}>
                        <span style={{ color: 'var(--accent)', fontWeight: 700, flexShrink: 0 }}>{i + 1}.</span>{v}
                      </div>
                    ))}
                  </div>
                )}

                {/* Bouton regénérer */}
                <button
                  onClick={genererAvecIA}
                  style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 16px', fontSize: 13, color: 'var(--muted)', cursor: 'pointer', fontFamily: 'DM Sans,sans-serif', marginTop: 8 }}
                >
                  Regénérer
                </button>
              </>
            )}
          </div>
        )}

        {/* ════════════════════════════════════
            ÉTAPE 4 — ACTIVATION
        ════════════════════════════════════ */}
        {etape === 4 && (
          <div>
            <div style={{ marginBottom: 28 }}>
              <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 11, color: 'var(--accent2)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 8 }}>Étape 4 / 5</div>
              <h2 style={{ fontFamily: 'Syne,sans-serif', fontSize: 24, fontWeight: 800, letterSpacing: '-0.8px', marginBottom: 8 }}>Contenus de diffusion</h2>
              <p style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.7 }}>
                {iaResult ? 'Vos contenus générés — prêts à copier et publier.' : 'Revenez à l\'étape 3 et générez votre ADN pour débloquer les contenus.'}
              </p>
            </div>

            {/* Message si pas encore générés */}
            {!iaResult && (
              <div style={{ background: 'rgba(74,150,150,0.06)', border: '1px solid rgba(74,150,150,0.12)', borderRadius: 10, padding: '20px', textAlign: 'center', color: 'var(--muted)', fontSize: 14 }}>
                Générez votre ADN à l'étape 3 pour débloquer vos contenus.
              </div>
            )}

            {/* Contenus disponibles après génération IA */}
            {iaResult && (
              <>
                {/* Pitch — déjà généré à l'étape 3 */}
                {[
                  { label: 'Pitch entreprise',       contenu: iaResult.pitch },
                  { label: 'Promesse employeur',      contenu: iaResult.promesse_employeur },
                  { label: 'Accroche page carrière',  contenu: iaResult.page_carriere_accroche },
                ].map((item, i) => (
                  <ContenuCopiable key={i} label={item.label} contenu={item.contenu}/>
                ))}
              </>
            )}
          </div>
        )}

        {/* ════════════════════════════════════
            ÉTAPE 5 — OPTIMISATION / SCORE
        ════════════════════════════════════ */}
        {etape === 5 && (
          <div>
            <div style={{ marginBottom: 28 }}>
              <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 11, color: 'var(--accent2)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 8 }}>Étape 5 / 5</div>
              <h2 style={{ fontFamily: 'Syne,sans-serif', fontSize: 24, fontWeight: 800, letterSpacing: '-0.8px', marginBottom: 8 }}>Score & Recommandations</h2>
              <p style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.7 }}>Évaluation de votre marque employeur.</p>
            </div>

            {/* Score depuis IA ou calcul local si pas encore généré */}
            {(() => {
              const score   = iaResult ? iaResult.score : Math.round((([form.pourquoi, form.probleme, form.ambition, form.valeurs, form.culture, form.avantages, form.evolution].filter(c => c && c.trim().length > 20).length) / 7) * 100);
              const niveau  = iaResult ? iaResult.niveau : (score >= 80 ? 'Avancé' : score >= 50 ? 'Structuré' : 'Débutant');
              const couleur = score >= 80 ? 'var(--success)' : score >= 50 ? 'var(--highlight)' : 'var(--error)';
              const axes    = iaResult ? iaResult.axes_amelioration : [];

              return (
                <>
                  {/* Carte score */}
                  <div style={{ background: 'var(--bg3)', border: `1px solid ${couleur}40`, borderRadius: 16, padding: '32px', textAlign: 'center', marginBottom: 20 }}>
                    <div style={{ fontFamily: 'Syne,sans-serif', fontSize: 80, fontWeight: 800, color: couleur, lineHeight: 1 }}>{score}</div>
                    <div style={{ color: 'var(--muted)', fontSize: 13, marginTop: 4, marginBottom: 16 }}>Score marque employeur / 100</div>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: `${couleur}15`, border: `1px solid ${couleur}40`, borderRadius: 20, padding: '6px 18px' }}>
                      <span style={{ width: 8, height: 8, borderRadius: '50%', background: couleur, display: 'inline-block' }}/>
                      <span style={{ color: couleur, fontWeight: 700, fontSize: 13 }}>Niveau : {niveau}</span>
                    </div>
                  </div>

                  {/* Axes d'amélioration IA */}
                  {axes.length > 0 && (
                    <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 12, padding: '20px 24px', marginBottom: 14 }}>
                      <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 11, color: 'var(--accent2)', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 14 }}>Axes d'amélioration</div>
                      {axes.map((axe, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '10px 0', borderBottom: i < axes.length - 1 ? '1px solid var(--border)' : 'none' }}>
                          <span style={{ color: 'var(--highlight)', flexShrink: 0, marginTop: 2 }}>○</span>
                          <span style={{ fontSize: 14, color: 'var(--text)', lineHeight: 1.6 }}>{axe}</span>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Bouton terminer */}
                  <button
                    onClick={() => navigate('/dashboard')}
                    style={{ width: '100%', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 10, padding: '14px 20px', fontSize: 15, fontWeight: 600, fontFamily: 'DM Sans,sans-serif', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 8 }}
                  >
                    Voir mon dashboard <IconArrow/>
                  </button>
                </>
              );
            })()}
          </div>
        )}

        {/* ── NAVIGATION ÉTAPES ── */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 32, paddingTop: 24, borderTop: '1px solid var(--border)' }}>

          {/* Bouton précédent */}
          <button
            onClick={precedent}
            disabled={etape === 1}
            style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: '1px solid var(--border)', borderRadius: 10, padding: '11px 20px', fontSize: 14, fontWeight: 500, color: etape === 1 ? 'var(--border)' : 'var(--muted)', cursor: etape === 1 ? 'not-allowed' : 'pointer', fontFamily: 'DM Sans,sans-serif' }}
          >
            <IconArrowLeft/> Précédent
          </button>

          {/* Indicateur étape */}
          <span style={{ fontFamily: 'DM Mono,monospace', fontSize: 11, color: 'var(--muted)' }}>
            {etape} / {ETAPES.length}
          </span>

          {/* Bouton suivant / terminer */}
          {etape < 5 ? (
            <button
              onClick={suivant}
              style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--accent)', border: 'none', borderRadius: 10, padding: '11px 24px', fontSize: 14, fontWeight: 600, color: '#fff', cursor: 'pointer', fontFamily: 'DM Sans,sans-serif' }}
            >
              Suivant <IconArrow/>
            </button>
          ) : (
            <button
              onClick={() => navigate('/dashboard')}
              style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--accent)', border: 'none', borderRadius: 10, padding: '11px 24px', fontSize: 14, fontWeight: 600, color: '#fff', cursor: 'pointer', fontFamily: 'DM Sans,sans-serif' }}
            >
              Terminer <IconArrow/>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}